import React from 'react';
import { Link } from 'react-router-dom';
import Projects from '../Projects/projects';
import Capabilities from './capabilities';
import Experience from '../about/experience';
import './home.css';

export default function Home() {
  return (
    <div className="home-container">
      {/* Hero Section */}
      <section className="hero-section">
        <div className="hero-content">
          <div className="text-content">
            <span className="hero-tag">Founding AI Engineer</span>
            <h1 className="hero-title">
              I build production-grade <span className="gradient-accent-text">AI systems</span> and scalable web platforms.
            </h1>
            
            <p className="hero-description">
              I bridge the gap between machine learning models and robust software engineering. 
              Specializing in autonomous agent networks, optimized vector database retrievals, and high-performance backends.
            </p>
            
            <div className="hero-ctas">
              <Link to="/projects" className="btn-primary">
                View Case Studies
              </Link>
              <Link to="/contact" className="btn-secondary">
                Book 15m Call
              </Link>
            </div>

            <div className="featured-stack">
              <span className="stack-title">Core Competencies</span>
              <div className="badge-row">
                <span className="tech-badge">Python</span>
                <span className="tech-badge">FastAPI</span>
                <span className="tech-badge">LangGraph</span>
                <span className="tech-badge">React.js</span>
                <span className="tech-badge">PostgreSQL</span>
                <span className="tech-badge">Docker</span>
                <span className="tech-badge">PyTorch</span>
              </div>
            </div>
          </div>
          
          <div className="hero-visual">
            <div className="visual-canvas premium-card">
              <div style={{ display: 'flex', gap: '1rem', width: '100%' }}>
                <span style={{ fontSize: '0.7rem', fontFamily: 'monospace', color: '#555' }}>[SYSTEM_INFERENCE_GATE]</span>
                <span style={{ marginLeft: 'auto', fontSize: '0.7rem', fontFamily: 'monospace', color: '#10b981' }}>● ONLINE</span>
              </div>
              <svg viewBox="0 0 300 200" width="100%" height="150px">
                <circle cx="50" cy="100" r="12" fill="#111" stroke="rgba(255,255,255,0.1)" />
                <circle cx="150" cy="50" r="12" fill="#111" stroke="#4F46E5" strokeWidth="1.5" />
                <circle cx="150" cy="150" r="12" fill="#111" stroke="rgba(255,255,255,0.1)" />
                <circle cx="250" cy="100" r="12" fill="#111" stroke="#10b981" strokeWidth="1.5" />

                <line x1="62" y1="96" x2="138" y2="54" stroke="#4F46E5" strokeWidth="1" strokeDasharray="3" />
                <line x1="62" y1="104" x2="138" y2="146" stroke="#555" strokeWidth="1" />
                <line x1="162" y1="54" x2="238" y2="96" stroke="#4F46E5" strokeWidth="1" />
                <line x1="162" y1="146" x2="238" y2="104" stroke="#555" strokeWidth="1" />

                <circle cx="100" cy="75" r="3.5" fill="#a5b4fc">
                  <animate attributeName="cx" values="62;138" dur="2s" repeatCount="indefinite" />
                  <animate attributeName="cy" values="96;54" dur="2s" repeatCount="indefinite" />
                </circle>
              </svg>
              <div style={{ width: '100%', fontSize: '0.75rem', fontFamily: 'monospace', color: '#8F8F93' }}>
                <div style={{ display: 'flex', borderBottom: '1px solid rgba(255,255,255,0.05)', padding: '0.35rem 0' }}>
                  <span>avg_latency</span>
                  <span style={{ marginLeft: 'auto', color: '#EDEDED' }}>12.4ms</span>
                </div>
                <div style={{ display: 'flex', borderBottom: '1px solid rgba(255,255,255,0.05)', padding: '0.35rem 0' }}>
                  <span>faithfulness_score</span>
                  <span style={{ marginLeft: 'auto', color: '#10b981' }}>0.96 (Ragas)</span>
                </div>
                <div style={{ display: 'flex', padding: '0.35rem 0' }}>
                  <span>routing_decision</span>
                  <span style={{ marginLeft: 'auto', color: '#a5b4fc' }}>vector_rag_route</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Dividers & Sections */}
      <div className="section-divider">
        <div className="line"></div>
        <span className="title">Capabilities Showcase</span>
        <div className="line"></div>
      </div>

      <Capabilities />

      <div className="section-divider">
        <div className="line"></div>
        <span className="title">Selected Projects</span>
        <div className="line"></div>
      </div>

      <Projects />

      <div className="section-divider">
        <div className="line"></div>
        <span className="title">Career Journey</span>
        <div className="line"></div>
      </div>

      <Experience />
    </div>
  );
}